import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';

import { getVoteCurrentActiveOptionId } from 'store/widgets/VoteForm/selectors';
import { changeVoteOption, submitVote } from 'store/widgets/VoteForm/actions';
import { Heading } from 'components';
import { TabsList, TabsItem } from 'bricks/Tabs';
import ReactiveButton from 'bricks/ReactiveButton';

import { getVotedAnswer } from '../../helpers';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export function VoteViewLayout({
  question,
  answers,
  buttonText,
  activeOptionId,
  onChangeVoteOption,
  onVoteSubmit,
  formViewChange,
  className,
  isMobile,
  heading,
  headingTagName,
}) {
  // ===
  const isNoActiveOptionChecked = !activeOptionId;
  // ===
  return (
    <div className={cx('wrapper', className, isMobile && 'mobile', 'column')}>
      <div className={cx('content', isMobile && 'mobile', 'wrapperCell')}>
        {heading ?
          <Heading
            tagName={headingTagName}
            level={isMobile ? 4 : 3}
            className={cx('heading', isMobile && 'mobile')}
          >
            {heading}
          </Heading>
        : null}
        {question ?
          <span className={cx('question', isMobile && 'mobile')}>{question}</span>
        : null}
      </div>
      <div className={cx('wrapperCell')}>
        <div className={cx('voteOptions', isMobile && 'mobile')}>
          <TabsList type="radio" onChange={onChangeVoteOption}>
            {answers.map(({ answerId, answerText }) => (
              <TabsItem
                className={cx('voteOption')}
                type="radio"
                id={answerId}
                isActive={answerId === activeOptionId}
                key={answerId}
              >
                {answerText}
              </TabsItem>
            ))}
          </TabsList>
          <div className={cx('buttonWrapper', isMobile && 'mobile')}>
            <ReactiveButton
              className={cx('button', isNoActiveOptionChecked && 'disabled')}
              isDisabled={isNoActiveOptionChecked}
              onClick={() => {
                onVoteSubmit(question, getVotedAnswer(activeOptionId, answers));
                formViewChange();
              }}
              isWide
              type="submit"
            >
              {buttonText}
            </ReactiveButton>
          </div>
        </div>
      </div>
    </div>
  );
}

VoteViewLayout.propTypes = {
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  heading: PropTypes.string,
  headingTagName: PropTypes.string,
  question: PropTypes.string,
  buttonText: PropTypes.string,
  answers: PropTypes.arrayOf(
    PropTypes.shape({
      answerId: PropTypes.string,
      answerText: PropTypes.string,
    }),
  ),
  /* redux-connected props */
  activeOptionId: PropTypes.string,
  onChangeVoteOption: PropTypes.func,
  onVoteSubmit: PropTypes.func,
  formViewChange: PropTypes.func,
};

VoteViewLayout.defaultProps = {
  formViewChange: () => {},
};

const mapStateToProps = (state) => ({
  activeOptionId: getVoteCurrentActiveOptionId(state),
});

const mapDispatchToProps = {
  onChangeVoteOption: changeVoteOption,
  onVoteSubmit: submitVote,
};

export default connect(mapStateToProps, mapDispatchToProps)(VoteViewLayout);
